export default function Marquee({ items, className = "", itemClassName = "" }) {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden whitespace-nowrap border-y border-terracotta/20 py-4 select-none ${className}`}
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className={`flex items-center ${itemClassName}`}>
                <span className="mx-6 font-serif text-lg md:text-xl tracking-wide">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-alta/70 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
